import { render, staticRenderFns } from "./caseManage.vue?vue&type=template&id=0d564752&scoped=true&"
import script from "./caseManage.vue?vue&type=script&lang=js&"
export * from "./caseManage.vue?vue&type=script&lang=js&"
import style0 from "./caseManage.vue?vue&type=style&index=0&id=0d564752&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d564752",
  null
  
)

export default component.exports